import React from 'react';
import PropTypes from 'prop-types';
import GenericTable from './GenericTable';
import { usuariosColumnConfig } from './config';
import { MOCK_USERS, PAGINATION_CONFIG } from '../../constants';


/**
 * Componente de tabla de usuarios con funcionalidades de búsqueda, ordenamiento y paginación
 * @param {Object} props - Props del componente
 * @param {Array} props.data - Array de objetos con datos de usuarios
 * @param {boolean} props.loading - Estado de carga (no implementado aún)
 * @returns {JSX.Element} Tabla de usuarios con todas las funcionalidades
 */
export default function TablaUsuarios({ data = MOCK_USERS, loading = false }) {
    return (
        <GenericTable
            data={data}
            columns={usuariosColumnConfig}
            loading={loading}
            searchable={true}
            searchFields={['identificacion', 'nombre','empresa', 'area', 'cargo' ]}
            title="Detalle de Usuarios"
            emptyMessage="No se encontraron resultados"
            rowsPerPageOptions={PAGINATION_CONFIG.rowsPerPageOptions}
        />
    );
}

TablaUsuarios.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            identificacion: PropTypes.string.isRequired,
            nombre: PropTypes.string,
            cargo: PropTypes.string,
            empresa: PropTypes.string,
            cantidadMediciones: PropTypes.number,
            participacion: PropTypes.number.isRequired,
        })
    ),
    loading: PropTypes.bool,
};
